import { graphql } from "@opensea/graphql"

export const TextOnlyFragment = graphql(`
  fragment TextOnly on CollectionNarrativeModule {
    title
    description
    horizontalTextPosition
    verticalTextPosition
    variant
  }
`)
